import React from 'react'
import { Bot } from 'lucide-react'

const icon = props => <Bot size={24} {...props} />

export default icon
